import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { CeIconComponent } from '@enginuity/core/atoms/ce-icon/ce-icon.component';

@Component({
  selector: 'app-icon-btn',
  templateUrl: './icon-btn.component.html',
  styleUrls: ['./icon-btn.component.scss'],
  imports: [CommonModule, CeIconComponent],
})
export class IconBtnComponent {
  constructor() {}

  @Input()
  active = false;

  @Input()
  size: 'medium' | 'full-width' | 'input-height' | 'large' = 'medium';

  @Input()
  type = 'button';

  @Input()
  iconType: string = 'change';

  @Input() disabled: boolean = false;
  @Input() loading: boolean = false;
  @Input() isLoading: boolean = false;

  get computedIconType(): string {
    return this.loading ? 'loader' : this.iconType;
  }
}
